import React, { Component } from 'react'

import withStyles from '@material-ui/core/styles/withStyles'
import HeaderLinks from './HeaderLinks.jsx'
import MaterialHeader from './Header.jsx'

import navbarsStyle from '../../assets/jss/material-kit-pro-react/views/componentsSections/navbarsStyle.jsx'

class Header extends Component {
  render() {
    const { classes, transparentHeader } = this.props
    return (
      <MaterialHeader
        color={transparentHeader ? 'transparent' : 'primary'}
        changeColorOnScroll={
          transparentHeader ? { height: 150, color: 'primary' } : {}
        }
        brand="BitNational"
        fixed
        links={<HeaderLinks />}
      />
    )
  }
}

export default withStyles(navbarsStyle)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx